<template>
    <div>
        <v-select
                v-model.trim="dataReport.dict1.mum_division"
                label="Отдел"
                :items="mum_divisions"
                :disabled="disableReport"
                v-if="!is_ministerstvo"
        ></v-select>
        <div v-if="is_ministerstvo">Отдел: {{dataReport.dict1.mum_division}}</div>
        <table>
            <tr>
                <th>№ п/п</th>
                <th>Наименование показателя</th>
                <th>Оценка показателя нарастающим итогом с начала года (или на конец отчетного периода)</th>
            </tr>
            <tr><td>1</td><td>Численность детей-сирот и детей, оставшихся без попечения родителей, в отношении которых прекращена семейная форма устройства, из них:</td>
                <td> {{1*dataReport.dict1.row_1_1 + 1*dataReport.dict1.row_1_2 + 1*dataReport.dict1.row_1_3 + 1*dataReport.dict1.row_1_4}}</td>
            </tr>
            <tr><td>1.1</td><td>находились под предварительной опекой </td><td> <v-text-field v-model.trim="dataReport.dict1.row_1_1" type="number" :disabled="disableReport"></v-text-field></td></tr>
            <tr><td>1.2</td><td>находились под безвозмездной опекой (попечительством)</td><td> <v-text-field v-model.trim="dataReport.dict1.row_1_2" type="number" :disabled="disableReport"></v-text-field></td></tr>
            <tr><td>1.3</td><td>находились в приемной семье</td><td> <v-text-field v-model.trim="dataReport.dict1.row_1_3" type="number" :disabled="disableReport"></v-text-field></td></tr>
            <tr><td>1.4</td><td>были усыновлены </td><td> <v-text-field v-model.trim="dataReport.dict1.row_1_4" type="number" :disabled="disableReport"></v-text-field></td></tr>
            <tr><td>2</td><td>Основания прекращения семейного устройства:</td>
                <td> {{1*dataReport.dict1.row_2_1_1 + 1*dataReport.dict1.row_2_1_2 + 1*dataReport.dict1.row_2_1_3 + 1*dataReport.dict1.row_2_1_4 + 1*dataReport.dict1.row_2_1_5 + 1*dataReport.dict1.row_2_2_1 + 1*dataReport.dict1.row_2_2_2 + 1*dataReport.dict1.row_2_2_3 + 1*dataReport.dict1.row_2_3}}</td>
            </tr>
            <tr><td>2.1</td><td>по инициативе органов опеки и попечительства:</td>
                <td> {{1*dataReport.dict1.row_2_1_1 + 1*dataReport.dict1.row_2_1_2 + 1*dataReport.dict1.row_2_1_3 + 1*dataReport.dict1.row_2_1_4 + 1*dataReport.dict1.row_2_1_5}}</td>
            </tr>
            <tr><td>2.1.1</td><td>в связи с ненадлежащим выполнением усыновителями, опекунами, попечителями, приемными родителями обязанностей по воспитанию детей </td><td> <v-text-field v-model.trim="dataReport.dict1.row_2_1_1" type="number" :disabled="disableReport"></v-text-field></td></tr>
            <tr><td>2.1.2</td><td>по причине жестокого обращения </td><td> <v-text-field v-model.trim="dataReport.dict1.row_2_1_2" type="number" :disabled="disableReport"></v-text-field></td></tr>
            <tr><td>2.1.3</td><td>в связи с нарушением усыновителями, опекунами, попечителями, приемными родителями правил охраны имущества подопечного и (или) распоряжения его имуществом</td><td> <v-text-field v-model.trim="dataReport.dict1.row_2_1_3" type="number" :disabled="disableReport"></v-text-field></td></tr>
            <tr><td>2.1.4</td><td>временно в случае возникновения противоречий между интересами подопечного и опекуна или попечителя</td><td> <v-text-field v-model.trim="dataReport.dict1.row_2_1_4" type="number" :disabled="disableReport"></v-text-field></td></tr>
            <tr><td>2.1.5</td><td>иное</td><td> <v-text-field v-model.trim="dataReport.dict1.row_2_1_5" type="number" :disabled="disableReport"></v-text-field></td></tr>
            <tr><td>2.2</td><td>по инициативе усыновителя, опекуна, попечителя, приемного родителя:</td>
                <td> {{1*dataReport.dict1.row_2_2_1 + 1*dataReport.dict1.row_2_2_2 + 1*dataReport.dict1.row_2_2_3}}</td>
            </tr>
            <tr><td>2.2.1</td><td>в связи с отсутствием взаимопонимания ребенка с опекуном, членами его семьи, в том числе связанное с неудовлетворительным поведением несовершеннолетнего</td><td> <v-text-field v-model.trim="dataReport.dict1.row_2_2_1" type="number" :disabled="disableReport"></v-text-field></td></tr>
            <tr><td>2.2.2</td><td>в связи с выявленными особенностями состояния здоровья ребёнка, потребностью в специализированной медицинской помощи, специальных условий ухода</td><td> <v-text-field v-model.trim="dataReport.dict1.row_2_2_2" type="number" :disabled="disableReport"></v-text-field></td></tr>
            <tr><td>2.2.3</td><td>иное </td><td> <v-text-field v-model.trim="dataReport.dict1.row_2_2_3" type="number" :disabled="disableReport"></v-text-field></td></tr>
            <tr><td>2.3</td><td>по инициативе несовершеннолетнего</td><td> <v-text-field v-model.trim="dataReport.dict1.row_2_3" type="number" :disabled="disableReport"></v-text-field></td></tr>
            <tr><td>3</td><td>Возраст детей, в отношении которых отменено семейное устройство  </td>
                <td> {{1*dataReport.dict1.row_3_1 + 1*dataReport.dict1.row_3_2 + 1*dataReport.dict1.row_3_3}}</td>
            </tr>
            <tr><td>3.1</td><td>до 7 лет</td><td> <v-text-field v-model.trim="dataReport.dict1.row_3_1" type="number" :disabled="disableReport"></v-text-field></td></tr>
            <tr><td>3.2</td><td>от 7 до 10 лет</td><td> <v-text-field v-model.trim="dataReport.dict1.row_3_2" type="number" :disabled="disableReport"></v-text-field></td></tr>
            <tr><td>3.3</td><td>от 10 до 18 лет</td><td> <v-text-field v-model.trim="dataReport.dict1.row_3_3" type="number" :disabled="disableReport"></v-text-field></td></tr>
            <tr><td>4</td><td>Период проживания ребенка в замещающей семье или в семье усыновителей</td>
                <td> {{1*dataReport.dict1.row_4_1 + 1*dataReport.dict1.row_4_2 + 1*dataReport.dict1.row_4_3}}</td>
            </tr>
            <tr><td>4.1</td><td>до 1 года</td><td> <v-text-field v-model.trim="dataReport.dict1.row_4_1" type="number" :disabled="disableReport"></v-text-field></td></tr>
            <tr><td>4.2</td><td>от 1 года до 5 лет</td><td> <v-text-field v-model.trim="dataReport.dict1.row_4_2" type="number" :disabled="disableReport"></v-text-field></td></tr>
            <tr><td>4.3</td><td>более 5 лет</td><td> <v-text-field v-model.trim="dataReport.dict1.row_4_3" type="number" :disabled="disableReport"></v-text-field></td></tr>
            <tr><td>5</td><td>Число детей, в отношении которых повторно отменена семейная форма устройства</td><td> <v-text-field v-model.trim="dataReport.dict1.row_5" type="number" :disabled="disableReport"></v-text-field></td></tr>
            <tr><td>6</td><td>Дальнейшее жизнеустройство детей-сирот и детей, оставшихся без попечения родителей:</td>
                <td> {{1*dataReport.dict1.row_6_1 + 1*dataReport.dict1.row_6_2 + 1*dataReport.dict1.row_6_3}}</td>
            </tr>
            <tr><td>6.1</td><td>число детей-сирот и детей, оставшихся без попечения родителей, устроенных в семью (опека/попечительство, в приемную семью, на усыновление)</td><td> <v-text-field v-model.trim="dataReport.dict1.row_6_1" type="number" :disabled="disableReport"></v-text-field></td></tr>
            <tr><td>6.2</td><td>число детей-сирот и детей, оставшихся без попечения родителей, помещенных в организации для детей-сирот и детей, оставшихся без попечения родителей</td><td> <v-text-field v-model.trim="dataReport.dict1.row_6_2" type="number" :disabled="disableReport"></v-text-field></td></tr>
            <tr><td>6.3</td><td>иное жизнеустройство </td><td> <v-text-field v-model.trim="dataReport.dict1.row_6_3" type="number" :disabled="disableReport"></v-text-field></td></tr>
            <tr><td>7</td><td>Численность замещающих родителей, освобожденных (отстранённых) от исполнения обязанностей, и усыновителей, в отношении которых принято решение суда об отмене усыновления, из них:</td>
                <td> {{1*dataReport.dict1.row_7_1 + 1*dataReport.dict1.row_7_2}}</td>
            </tr>
            <tr><td>7.1</td><td>посторонние граждане</td><td> <v-text-field v-model.trim="dataReport.dict1.row_7_1" type="number" :disabled="disableReport"></v-text-field></td></tr>
            <tr><td>7.2</td><td>родственники</td><td> <v-text-field v-model.trim="dataReport.dict1.row_7_2" type="number" :disabled="disableReport"></v-text-field></td></tr>
            <tr><td>8</td><td>Численность усыновителей, опекунов, попечителей, приемных родителей,  прошедших подготовку в школе приемных родителей</td><td> <v-text-field v-model.trim="dataReport.dict1.row_8" type="number" :disabled="disableReport"></v-text-field></td></tr>
            <tr><td>9</td><td>Численность усыновителей, опекунов, попечителей, приемных родителей,  прошедших психологическое обследование в школе приемных родителей</td><td> <v-text-field v-model.trim="dataReport.dict1.row_9" type="number" :disabled="disableReport"></v-text-field></td></tr>
            <tr><td>10</td><td>Организация сопровождения замещающих семей и семей усыновителей, из числа семей, в которых прекращена семейная форма устройства детей-сирот и детей, оставшихся без попечения родителей </td>
                <td> {{1*dataReport.dict1.row_10_1 + 1*dataReport.dict1.row_10_2_1 + 1*dataReport.dict1.row_10_2_2 + 1*dataReport.dict1.row_10_2_3}}</td>
            </tr>
            <tr><td>10.1</td><td>число усыновителей, опекунов, попечителей, приемных родителей, никогда не состоявших на сопровождении</td><td> <v-text-field v-model.trim="dataReport.dict1.row_10_1" type="number" :disabled="disableReport"></v-text-field></td></tr>
            <tr><td>10.2</td><td>число усыновителей, опекунов, попечителей, приемных родителей, состоявших на сопровождении:</td>
                <td> {{1*dataReport.dict1.row_10_2_1 + 1*dataReport.dict1.row_10_2_2 + 1*dataReport.dict1.row_10_2_3}}</td>
            </tr>
            <tr><td>10.2.1</td><td>до 3 месяцев</td><td> <v-text-field v-model.trim="dataReport.dict1.row_10_2_1" type="number" :disabled="disableReport"></v-text-field></td></tr>
            <tr><td>10.2.2</td><td>от 3 месяцев до года</td><td> <v-text-field v-model.trim="dataReport.dict1.row_10_2_2" type="number" :disabled="disableReport"></v-text-field></td></tr>
            <tr><td>10.2.3</td><td>более года </td><td> <v-text-field v-model.trim="dataReport.dict1.row_10_2_3" type="number" :disabled="disableReport"></v-text-field></td></tr>
            <tr><td>11</td><td>Число усыновителей, опекунов, попечителей, приемных родителей, с которыми расторгнуты договоры о сопровождении по их инициативе</td><td> <v-text-field v-model.trim="dataReport.dict1.row_11" type="number" :disabled="disableReport"></v-text-field></td></tr>

        </table>
        <v-card-actions
                v-if="this.$route.params.report_id !== 'new'"
        >
            <v-spacer></v-spacer>
            <v-btn
                    @click.native="get_report('get_report_form_002', 'Отчет.xlsx')">Отчет
            </v-btn>
        </v-card-actions>
    </div>
</template>

<script>
export default {
  name: 'form001',
  props: {
    dataReport: {
      type: Object,
      default: function () {
        return { table1: [] }
      }
    },
    disableReport: {
      type: Boolean,
      default: function () {
        return true
      }
    }
  },
  data () {
    return {
      itemsYesNo: ['Да', 'Нет'],
      items6: ['ежедневно', 'еженедельно', 'ежемесячно', 'ежегодно']
    }
  },
  computed: {
    user () {
      return this.$store.getters['auth/user']
    },
    mum_divisions () {
      return this.$store.getters['reportingReport/get_mum_divisions'](this.user.department.ogrn)
    },
    is_ministerstvo () {
      return this.user.department.ogrn === '1073808028271'
    }
  },
  methods: {
    get_report (urlFile, filename) {
      this.$store.dispatch('reportingReport/downloadFile',
        { id: this.$route.params.report_id, urlFile, filename })
    }
  }
}
</script>

<style scoped>
    table, td, th {
        /*text-align: left;*/
        /*padding: 1px;*/
        border: solid black 1px;
        border-collapse: collapse;
    }
    th {
        vertical-align: top;
        /*text-align: center;*/
    }
    td {
        vertical-align: bottom;
    }
    .td_sum {
        padding-bottom: 27px;
        font-weight: bold;
    }
    .bloc_inline
    {
        display:inline-block;
    }
    .bloc
    {
        border: 1px solid gray
    }

</style>
